/* assets/event-code.js — store-event code helpers (snippets/event-code.liquid).
   • [data-ev-copy] buttons copy the code and announce "Copied" in the nearest [data-ev-copied] live region.
   • [data-ev-end="YYYY-MM-DD"] elements hide once that date has passed in the visitor's time zone (pages can be cached). */
(function () {
  'use strict';
  var d = new Date();
  var p = function (n) { return n < 10 ? '0' + n : '' + n; };
  var today = '' + d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate());
  function sweep(root) {
    var list = (root && root.querySelectorAll ? root : document).querySelectorAll('[data-ev-end]');
    for (var i = 0; i < list.length; i++) {
      var end = (list[i].getAttribute('data-ev-end') || '').replace(/-/g, '');
      if (end.length === 8 && today > end) { list[i].hidden = true; list[i].setAttribute('data-ev-expired', ''); }
    }
  }
  function say(btn, text) {
    var box = btn.closest('[data-ev]'); var live = box && box.querySelector('[data-ev-copied]');
    if (live) { live.textContent = text; clearTimeout(live._t); live._t = setTimeout(function () { live.textContent = ''; }, 2200); }
    btn.classList.add('is-copied'); clearTimeout(btn._t); btn._t = setTimeout(function () { btn.classList.remove('is-copied'); }, 2200);
  }
  function fallback(code, btn) {
    try {
      var ta = document.createElement('textarea'); ta.value = code; ta.setAttribute('readonly', '');
      ta.style.position = 'fixed'; ta.style.top = '-1000px'; ta.style.fontSize = '16px';
      document.body.appendChild(ta); ta.select(); var ok = document.execCommand('copy'); document.body.removeChild(ta);
      say(btn, ok ? 'Copied: ' + code : 'Code: ' + code);
    } catch (e) { say(btn, 'Code: ' + code); }
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ev-copy]'); if (!btn) return;
    e.preventDefault();
    var code = btn.getAttribute('data-ev-copy') || '';
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(function () { say(btn, 'Copied: ' + code); }, function () { fallback(code, btn); });
    } else { fallback(code, btn); }
  });
  sweep();
  document.addEventListener('DOMContentLoaded', function () { sweep(); });
  if (window.MutationObserver) {
    var q = false;
    new MutationObserver(function () { if (q) return; q = true; requestAnimationFrame(function () { q = false; sweep(); }); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
